import { FC, ReactNode } from "react";
import { styled, SxProps, Theme } from "@mui/material";

type ContentWrapperProps = {
  children: ReactNode | undefined;
  sx?: SxProps<Theme>;
};

const ContentWrapper: FC<ContentWrapperProps> = ({ children, sx }) => {
  return <Wrapper sx={sx}>{children}</Wrapper>;
};

const Wrapper = styled("div")`
  width: 100%;
  max-width: 1560px;
  border: var(--border);
  // border-color: ${({ theme }) => theme.palette.divider};
  border-top: none;
  border-bottom: none;
  border:none;
  margin: 0 auto;
  flex-grow: 1;
  background-color: #ccc;
`;

export default ContentWrapper;
